import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../common/html/checkbox'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../../helpers/EventEmitter'

export const CheckboxCellTable = ({
  val,
  colors,
  setColors,
  selectListChart,
  changeListChart,
}) => {
  const dispatch = useDispatch()

  const listChartScore = useSelector(selectListChart)
  const isChecked = listChartScore.map((item) => item.val).includes(val)
  const { color } = listChartScore.find((item) => item.val === val) || {}
  const listChartIgnoreCurrent = listChartScore.filter(
    (item) => item.val !== val,
  )

  const onChange = (checked) => {
    if (checked) {
      if (listChartScore.length >= 4) {
        EventEmitter.dispatch(SHOW_POPUP_ERROR, {
          messages: [
            <Translate
              value={
                'companyAnalysis.peerAnalysis.OVER_SELECTION_CHART_POPUP_TEXT'
              }
            />,
          ],
        })
      } else {
        if (colors.length) {
          dispatch(
            changeListChart([
              ...listChartScore,
              { val, color: colors[0]?.color },
            ]),
          )
          colors.shift()
          setColors(colors)
        }
      }
    } else {
      setColors([...colors, { color }])
      dispatch(changeListChart(listChartIgnoreCurrent))
    }
  }

  return (
    <Checkbox
      styleIcon={{ color: isChecked ? color : '#9C9C9C' }}
      value={val}
      checked={isChecked}
      onChange={onChange}
    />
  )
}
